"use strict";

const BOOK_DETAILS_TEMPLATE = `
	<div class="row">
		<div class="col-lg-12 full-book p0">
			<header class="col-lg-12 p0">
				<div class="col-lg-3 col-sm-4 full-height" style="background: #fff url('./assets/images/<%= img %>') no-repeat center center"></div>
				<div class="col-lg-9 col-sm-8 px-40 py-20">
					<h1 class="book-title"><%= title %></h1>
					<div class="col-lg-12 col-sm-12 p0">
						<div class="col-lg-6 col-md-6 col-sm-12 p0">
							<h3 class="authors m0 inline-block"><%= app.localeManager.get("book.by") %></h3> <% _.each(authors, function(author) { %>
								<a href="./index.html#<%= app.getLanguage() %>/author/<%= author.name %>"><h3 class="m0 inline-block"><%= author.name %></h3></a>
								<% }); %>
							</h3>
						</div>
						<div id="level-component" class="col-lg-6 col-md-6 col-sm-12 p0 pull-right levels"></div>
					</div>

					<% if(!_.objIsEmpty(audiobook)) { %>
					<a class="btn btn-round show-audio-options mright-10 mtop-15 hvr-pop" data-id="<%= book_id %>">
						<i class="fa fa-headphones"></i>
						<%= app.localeManager.get("buttons.listen") %>
					</a>
					<% } %>
					<a class="btn btn-round show-options mtop-15 hvr-pop" data-id="<%= book_id %>">
						<i class="fa fa-book"></i>
						<%= app.localeManager.get("buttons.download") %>
					</a>
				</div>
			</header>
		<div class="clearfix"></div>
		<div id="separator" class="col-lg-9 col-md-12 col-sm-12 col-xs-12 pull-right px-40">
			<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 underlined"></div>
		</div>
		<div class="clearfix"></div>
		<article class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p40">
			<% if (_.isEmpty(description)) { %>
				<p class="book-description m0"><%= app.localeManager.get("book.noDescription") %></p>
			<% } else { %>
					<p class="book-description m0"><%= description %></p>
			<% } %>
			<div class="show-more-end"></div>
		</article>
		<div class="clearfix"></div>
			<article class="col-lg-12 center pbottom-40">
				<button name="show-more-btn" class="btn btn-barebone show-more center"><%= app.localeManager.get("buttons.show_more") %></button>
			</article>
		<div class="clearfix"></div>
		<article class="col-lg-12 book-details px-40 pbottom-40 hidden">
			<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pbottom-40">
				<div class="underlined col-lg-12 col-md-12 col-sm-12 col-xs-12"></div>
			</div>
			<!-- FIRST ROW -->
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.illustrator") %></h4>
				<% if(illustrators === null) { %>
					<h5>N/A</h5>
				<% } %>
				<% _.each(illustrators, function(illustrator) { %><h5><%= illustrator.name %></h5> <% }); %>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.narrator") %></h4>
				<h5><%= narrator == null || "" ? "N/A" : narrator %></h5>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.author") %></h4>
				<% if(_.objIsEmpty(authors)) { %>
				<h5>N/A</h5>
				<% } %>
				<% _.each(authors, function(author) { %>
					<a href="./index.html#<%= app.getLanguage() %>/author/<%= author.name %>">
						<h5><%= author.name %></h5>
					</a> 
				<% }); %>
			</div>
			<!-- SECOND ROW -->
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.country") %></h4>
				<h5><%= country == null ? "N/A" : app.localeManager.get("country." + country.toLowerCase()) %></h5>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.year") %></h4>
				<h5><%= year == null ? "N/A" : year %></h5>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.readingLevel") %></h4>
				<h5><%= reading_level == null ? "N/A" : reading_level %></h5>
			</div>
			<!-- THIRD ROW -->
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.nbPages") %></h4>
				<h5><%= nbPages == null ? "N/A" : nbPages %></h5>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.theme") %></h4>
				<% if(_.objIsEmpty(theme)) { %>
				<h5>N/A</h5>
				<% } %>
				<% _.each(theme, function(theme) { %>
					<a href="./index.html#<%= app.getLanguage() %>/findBy/theme=<%= theme.name %>">
						<h5><%= app.localeManager.get("themes." + theme.name.toLowerCase()) %></h5>
					</a>
				<% }); %>
			</div>
			<!-- FOURTH ROW -->
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-4 p0">
				<h4><%= app.localeManager.get("book.publisher") %></h4>
				<h5><%= publisher == null ? "N/A" : publisher %></h5>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-6 p0">
				<h4><%= app.localeManager.get("book.copyright") %></h4>
				<h5><%= copyright == null ? "N/A" : copyright %></h5>
			</div>
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 p0">
				<h4><%= app.localeManager.get("book.citation") %></h4>
				<h5><%= citation %></h5>
			</div>
			<div class="clearfix"></div>
		</article>
	</div>
`;

const BookDetailsComponent = Backbone.View.extend({

    className: "container py-40",

    components: {
		downloadModal: {},
		level: {}
    },

	events: {
		"click button[name=show-more-btn]"  : "showMore",
        "click .show-options"               : "showOptions",
		"click .show-audio-options"         : "showAudioOptions"
	},

    tagName: "section",

	template: _.template( BOOK_DETAILS_TEMPLATE ),

	initialize: function() {
		this.components.level = new Level({ model: this.model.toJSON() });
	},

    afterRender: function() {
       // required by the base app object
    },

    render: function() {
		this.$el.html(this.template(this.model.toJSON()));
		this.$el.find("#level-component").html(this.components.level.render().el);

        return this;
    },

    // Show more details about the book
	showMore: function(e) {
		$(".show-more-end").hide();
		$(e.target).parent().hide();
		$(".book-details").slideDown(200).toggleClass("hidden");
    },

    // Open the download dialog and offer the download options to the user
    showOptions: function() {
        // Create the view
        this.components.downloadModal = new BookDownloadModalComponent({ model: this.model, trigger: ".show-options" });
        $(document.body).append(this.components.downloadModal.render().el);
        this.components.downloadModal.open();
    },
    
    showAudioOptions: function() {
        this.components.downloadModal = new BookDownloadModalComponent({ model: this.model, trigger: ".show-options" });
        $(document.body).append(this.components.downloadModal.render().el);
        this.components.downloadModal.selectAudiobook();
        this.components.downloadModal.open();
    }

});